import { ref } from 'vue'

export default {
    name: 'StickySliderElement',
    setup() {
        const imgTopPosSticky = ref('40px')
        const imgTopPosStickyInt = ref(40)

        addEventListener('DOMContentLoaded', (event) => {
            const stickySliderElementImageContainer = document.querySelectorAll(
                '.kb-sticky-slider-element__content-container'
            )

            const getImageStickyTopPosition = () => {
                const stickySliderElement = document.querySelector(
                    '.kb-js--sticky-slider-element'
                )

                if (stickySliderElement) {
                    setImgTopPosSticky(stickySliderElement)
                }
            }
            const observer = new IntersectionObserver(handleIntersection, {
                rootMargin: `-${imgTopPosSticky.value}`
            })

            stickySliderElementImageContainer.forEach((stickyElm) => {
                observer.observe(stickyElm)
            })

            stickySliderElementImageContainer.forEach((stickyElm, index) => {
                if (index + 1 < stickySliderElementImageContainer.length) {
                    const imageContainer = stickyElm.querySelector(
                        '.kb-js--sticky-slider-image-container'
                    )
                    const image = imageContainer.querySelector(
                        '.kb-js--sticky-slider-element'
                    )
                    const totalContainerHeight =
                        imageContainer.getBoundingClientRect().height +
                        image.getBoundingClientRect().height * 2
                    stickyElm.style.height = `${imageContainer.getBoundingClientRect().height * 2}px`
                    imageContainer.style.height = `${totalContainerHeight}px`
                }
            })

            const resizeObserver = new ResizeObserver(handleResize)

            stickySliderElementImageContainer.forEach((stickyElm) => {
                const containerRight = stickyElm.querySelector(
                    '.kb-js--sticky-container-right'
                )
                const textContentArea = containerRight.children[0]
                resizeObserver.observe(
                    textContentArea ? textContentArea : containerRight
                )
            })
        })

        const setImgTopPosSticky = (stickySliderElement) => {
            imgTopPosSticky.value =
                window.getComputedStyle(stickySliderElement).top
            imgTopPosStickyInt.value = parseFloat(
                imgTopPosSticky.value.replace('px', '')
            )
        }

        const handleIntersection = (entries) => {
            entries.map((entry) => {
                if (
                    entry.isIntersecting &&
                    imgTopPosStickyInt.value &&
                    entry.intersectionRect.top <= imgTopPosStickyInt.value
                ) {
                    if (!entry.target) return
                    changeBackgroundColor(entry.target)
                    changeImage(entry.target)
                } else if (
                    !entry.isIntersecting &&
                    entry.boundingClientRect.top < 0
                ) {
                    const nextElement = getNextElement(entry.target)
                    if (!nextElement) return
                    changeBackgroundColor(nextElement)
                    changeImage(nextElement)
                }
            })
        }

        const getNextElement = (currentElement) => {
            let currentIndex = 0
            const containers = document.querySelectorAll(
                '.kb-js--content-container'
            )
            Array.from(containers).map((item, index) => {
                if (item === currentElement) {
                    currentIndex = index
                }
            })

            if (currentIndex < containers.length) {
                return containers[currentIndex + 1]
            }
            return currentElement
        }

        const changeBackgroundColor = (elm) => {
            const parentContainer = elm.closest('.kb-sticky-slider-element')
            const parentClasses = parentContainer.classList
            parentClasses.forEach((item) => {
                if (item.includes('kb-colortheme')) {
                    parentContainer.classList.remove(item)
                }
            })

            if (elm.dataset.theme) {
                parentContainer.classList.add(elm.dataset.theme)
            }
        }

        const changeImage = (elm) => {
            const imageContainers = document.querySelectorAll(
                '.kb-js--sticky-slider-image-container'
            )
            const imageContainer = elm.querySelector(
                '.kb-js--sticky-slider-image-container'
            )
            imageContainers.forEach((container) =>
                container.classList.remove(
                    'kb-sticky-slider-element__left-container--shown'
                )
            )
            imageContainer.classList.add(
                'kb-sticky-slider-element__left-container--shown'
            )
        }

        // resize observer to make sure tekst content doesn't overlab
        const handleResize = (entries) => {
            entries.forEach((entry) => {
                const contentWrapper = entry.target.closest(
                    '.kb-js--content-container'
                )
                const textContentHeight = entry.contentRect.height
                const imgHeight = contentWrapper
                    .querySelector('.kb-js--sticky-slider-element')
                    .getBoundingClientRect().height
                if (contentWrapper && textContentHeight) {
                    if (imgHeight > textContentHeight) {
                        contentWrapper.style.height = `${imgHeight}px`
                    } else {
                        contentWrapper.style.height = `${textContentHeight}px`
                    }
                }
            })
        }
    }
}
